

































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Communicate } from '../../../src_server/entity/generated/Communicate';
import YoutubeFrame from '../../components/inputs/YoutubeFrame.vue';
import { ActorType, CommunicationMethod, Deafness } from '../../../src_server/biz/ActorType';
import { InputPages } from '../../components/organisms/InputPages';

@Component({
  components: { YoutubeFrame },
})
export default class TeacherCommunication2Page extends InputPages {
  @Prop()
  value!: Communicate;

  @Watch('model.sign_language')
  @Watch('model.corresponding_sign_language')
  @Watch('model.pronunciation')
  detect() {
    console.log('detect');
    const teacherActor = ActorType.getInstance(
      this.model.hearing_type as Deafness,
      true,
      this.model.sign_language as CommunicationMethod,
      this.model.corresponding_sign_language as CommunicationMethod,
      this.model.pronunciation as CommunicationMethod
    );
    this.model.actor_type = teacherActor.type;
  }
  get model() {
    return this.value;
  }

  set model(value) {
    this.value = value;
  }
}
